export function createAdminGitHubCommitUrl(commitHash?: string): string {
    return `https://github.com/pidedirecto/pidedirectoadmin/commits/${commitHash ?? ''}`;
}
